var map = {
	"./Devil.png": 846,
	"./action.png": 847,
	"./adventure.png": 848,
	"./alien.PNG": 849,
	"./animal.png": 850,
	"./anvil.png": 851,
	"./armor.png": 852,
	"./beer.png": 853,
	"./castle.png": 854,
	"./cat.png": 855,
	"./character.png": 856,
	"./city.png": 857,
	"./clover.png": 858,
	"./crown.png": 859,
	"./currency.png": 860,
	"./description.png": 861,
	"./dice.png": 862,
	"./dictator.png": 863,
	"./die.png": 864,
	"./dog.png": 865,
	"./drink.png": 866,
	"./dungeon.png": 867,
	"./dwarf.png": 868,
	"./encounter.png": 869,
	"./enemy.png": 870,
	"./fantasy.png": 871,
	"./fish.png": 872,
	"./food.png": 873,
	"./formal.png": 874,
	"./fortress.png": 875,
	"./friend.png": 876,
	"./generator.png": 877,
	"./ghost.png": 878,
	"./gold.png": 879,
	"./hammer.png": 880,
	"./hydra.png": 881,
	"./item.png": 882,
	"./key.png": 883,
	"./king.png": 884,
	"./kraken.png": 885,
	"./lock.png": 886,
	"./magic.png": 887,
	"./money.png": 888,
	"./monster.png": 889,
	"./mummy.png": 890,
	"./mushroom.png": 891,
	"./name.png": 892,
	"./noble.png": 893,
	"./npc.png": 894,
	"./person.png": 895,
	"./place.png": 896,
	"./plant.png": 897,
	"./potion.png": 898,
	"./rank.png": 899,
	"./reward.png": 900,
	"./room.png": 901,
	"./salami.png": 902,
	"./sea.png": 903,
	"./set.png": 904,
	"./simple.png": 905,
	"./soldier.png": 906,
	"./space.png": 907,
	"./spell.png": 908,
	"./standard.png": 168,
	"./sun.png": 909,
	"./sushi.png": 910,
	"./sword.png": 911,
	"./table.png": 912,
	"./template.png": 913,
	"./test.png": 914,
	"./title.png": 915,
	"./troll.png": 916,
	"./trophy.png": 917,
	"./vampire.png": 918,
	"./viking.png": 919,
	"./village.png": 920,
	"./villain.png": 921,
	"./wolf.png": 922
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 270;


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards ^\.\/.*$
// module id = 270
// module chunks = 64